import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';


@Injectable()
export class JWTInterceptorService  implements HttpInterceptor {


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        console.log('Interceptor HTTP');

        const jwt = localStorage.getItem('Authorization');

        if(jwt != null && !req.url.includes('create-user')) {

            // we have modified the initial request's header by adding the Authorization token
            const request = req.clone({setHeaders:{'Authorization':jwt}});

            // we are processing the request
            return next.handle(request);

        } else {

                return next.handle(req);
            }

    }




}
